"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fontWeights = void 0;
var fontWeights_1 = __importDefault(require("../tokens/fontWeights"));
exports.fontWeights = fontWeights_1.default;
//# sourceMappingURL=fontWeights.js.map